webpackJsonp([28],{

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _Lists = __webpack_require__(667);

var _Heading = __webpack_require__(565);

var _Heading2 = _interopRequireDefault(_Heading);

var _Heading3 = __webpack_require__(560);

var _Heading4 = _interopRequireDefault(_Heading3);

var _Paragraph = __webpack_require__(543);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

var _Menu = __webpack_require__(608);

var _Menu2 = _interopRequireDefault(_Menu);

var _NewFooterV = __webpack_require__(544);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

__webpack_require__(877);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
    var headData = _ref.headData;
    return _react2.default.createElement(
        _react.Fragment,
        null,
        headData && _react2.default.createElement(
            _reactStatic.Head,
            null,
            _react2.default.createElement(
                'title',
                null,
                headData.pageTitle
            ),
            _react2.default.createElement('meta', { property: 'og:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'twitter:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { name: 'twitter:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { name: 'twitter:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { property: 'og:url', content: headData.ogUrl }),
            _react2.default.createElement('link', { rel: 'canonical', href: headData.ogUrl }),
            _react2.default.createElement('meta', { name: 'robots', content: 'noindex,nofollow' })
        ),
        _react2.default.createElement(_Menu2.default, { whiteBackground: true, isNewHome: true }),
        _react2.default.createElement(
            'div',
            { className: 'main-content container privacyNotice' },
            _react2.default.createElement(
                _Heading2.default,
                { center: true, className: 'title' },
                'Aviso de Privacidade'
            ),
            _react2.default.createElement(
                _Paragraph2.default,
                null,
                'A ',
                _react2.default.createElement(
                    'strong',
                    null,
                    'Mercos'
                ),
                ' (SIMPLEST SOFTWARE LTDA ME - 12.496.510/0001-80) est\xE1 comprometida em resguardar sua privacidade e proteger seus dados pessoais. Esse Aviso de Privacidade busca esclarecer como coletamos, usamos, compartilhamos e armazenamos suas informa\xE7\xF5es e documentos.'
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '1. INTRODU\xC7\xC3O'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'A busca da Mercos pela melhoria cont\xEDnua est\xE1 diretamente ligada com a coleta e o tratamento de determinadas informa\xE7\xF5es de seus clientes, seja atrav\xE9s do envio direto ou atrav\xE9s do uso de software.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'O presente Aviso de Privacidade explicar\xE1 a voc\xEA, de forma clara e acess\xEDvel, quais ser\xE3o seus dados pessoais coletados, com quem ser\xE3o compartilhados e em que locais ser\xE3o armazenados.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Tendo como base a Lei Geral de Prote\xE7\xE3o de Dados (Lei n\xBA 13.709/2018) que regula as atividades de tratamento de dados pessoais, e o Marco Civil da Internet (Lei 12.965/2014) que estabelece princ\xEDpios, garantia, direitos e deveres para o uso da internet no Brasil.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Sugerimos tamb\xE9m a leitura dos nossos ',
                    _react2.default.createElement(
                        'a',
                        { href: 'https://mercos.com/termos-e-condicoes/', target: '_blank', rel: 'noreferrer' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Termos de Uso'
                        )
                    ),
                    '.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '2. COMO A MERCOS RECOLHE OS DADOS PESSOAIS'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'A Mercos coleta os dados pessoais da seguinte forma:'
                ),
                _react2.default.createElement(
                    _Lists.OrderedList,
                    null,
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Envio pelo interm\xE9dio do site da Mercos:'
                        ),
                        ' A Mercos recebe e armazena todas as informa\xE7\xF5es que lhe s\xE3o fornecidas atrav\xE9s de formul\xE1rios presentes em seu site;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Utiliza\xE7\xE3o dos software e servi\xE7os da Mercos:'
                        ),
                        ' Eventualmente, a Mercos aciona determinados atributos de seu Software os quais ir\xE3o capturar e armazenar informa\xE7\xF5es de uso do software;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Parceiros:'
                        ),
                        ' A Mercos recebe determinadas informa\xE7\xF5es atrav\xE9s de parceiros. A Mercos utiliza estes dados apenas caso o titular dos mesmos tiver autorizado os parceiros a efetuar a partilha desses ou caso tenha um leg\xEDtimo interesse em utilizar os mesmos;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Dados de colaboradores de Clientes:'
                        ),
                        ' A Mercos recebe e armazena dados pessoais de colaboradores de Clientes apontados para centralizar abertura de chamados para o servi\xE7o de suporte da Mercos;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Dados de signat\xE1rios de Contratos:'
                        ),
                        ' A Mercos recebe dados de representantes legais e testemunhas apontadas como signat\xE1rios de contratos e aditivos firmados com clientes, prestadores de servi\xE7os e fornecedores.'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Recursos de Intelig\xEAncia Artificial:'
                        ),
                        ' A Mercos poder\xE1 coletar e tratar dados pessoais por meio de intera\xE7\xF5es realizadas de atrav\xE9s funcionalidades baseadas em intelig\xEAncia artificial (\u201CFuncionalidades de IA\u201D), disponibilizado na plataforma Mercos e/ou em canais externos como WhatsApp. Os dados tratados neste contexto incluem: (a) conte\xFAdo das mensagens trocadas nas Funcionalidades de IA; (b) dados pessoais de clientes e terceiros consultados ou referenciados nas intera\xE7\xF5es; (c) dados de identifica\xE7\xE3o do usu\xE1rio que aciona tais Funcionalidades; (d) metadados das intera\xE7\xF5es, como data, hora e canal utilizado.'
                    )
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'A Mercos utiliza informa\xE7\xF5es tornadas an\xF4nimas e agregadas para fins que incluem testar seus sistemas de TI, investiga\xE7\xE3o, an\xE1lise de dados, criar modelos de marketing e promo\xE7\xE3o, melhorar seus softwares e servi\xE7os e desenvolver novos recursos e funcionalidades.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '2.1 QUAIS DADOS A MERCOS COLETA E DE QUE FORMA OS UTILIZA'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'S\xE3o os dados utilizados durante a contrata\xE7\xE3o, cadastramento, utiliza\xE7\xE3o ou intera\xE7\xE3o com nossos servi\xE7os.'
                ),
                _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Categoria'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Descri\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Utilidade'
                            ),
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Fundamento para coleta'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Utiliza\xE7\xE3o dos Softwares'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'S\xE3o dados pessoais coletados dos usu\xE1rios do software da Mercos e incluem: ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(a)'
                                ),
                                ' endere\xE7o de Protocolo de Internet (IP); ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' log in; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(c)'
                                ),
                                ' endere\xE7o de e-mail; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(d)'
                                ),
                                ' informa\xE7\xF5es sobre computador e conex\xE3o, como tipo de navegador, vers\xE3o e fuso hor\xE1rio, tipos e vers\xE3o de navegador, sistema operacional e plataforma, bem como informa\xE7\xF5es relacionadas ao uso do software, como: ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(a)'
                                ),
                                ' hor\xE1rio e local de acesso; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' atividades realizadas; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(c)'
                                ),
                                ' tempo de uso; entre outros.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Analisar de que forma os usu\xE1rios interagem com as ferramentas a fim de corrigir potenciais erros, bem como desenvolver novas funcionalidades, na busca pela melhoria cont\xEDnua dos softwares da Mercos'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Cumprimento de Execu\xE7\xE3o Contratual.'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Pesquisa de Satisfa\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'S\xE3o dados pessoais coletados atrav\xE9s de pesquisas encaminhadas ao indiv\xEDduo de tempos em tempos, tais como: ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(a)'
                                ),
                                ' avalia\xE7\xE3o do software (nota) e justificava; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' fun\xE7\xE3o do usu\xE1rio; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(c)'
                                ),
                                ' departamento; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(d)'
                                ),
                                ' e-mail; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(e)'
                                ),
                                ' sistemas utilizados.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Medir o n\xEDvel de satisfa\xE7\xE3o de usu\xE1rios do software Mercos, bem como coletar sugest\xF5es de melhoria.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Interesse leg\xEDtimo.'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Contatos Diretos'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'S\xE3o dados pessoais coletados diretamente por determinadas \xE1reas (ouvidoria, SDR e SAC) da Mercos via contato telef\xF4nico.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Atender chamados referentes ao software; atender manifesta\xE7\xF5es; prospectar clientes; etc.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Interesse leg\xEDtimo.'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Dados de Marketing'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'S\xE3o dados pessoais coletados atrav\xE9s de formul\xE1rios disponibilizados no website\xB2 da Mercos, sendo os principais deles: ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(a)'
                                ),
                                ' e-mail; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' nome completo; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(c)'
                                ),
                                ' cargo que ocupa em sua organiza\xE7\xE3o; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(d)'
                                ),
                                ' telefone comercial; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(e)'
                                ),
                                ' empresa em que trabalha; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(f)'
                                ),
                                ' pa\xEDs ou regi\xE3o; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(g)'
                                ),
                                ' skype; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(h)'
                                ),
                                ' celular, etc.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Realizar comunica\xE7\xF5es\xB3 com os clientes da Mercos bem como demais terceiros, acerca de: ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(a)'
                                ),
                                ' campanhas de marketing; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' informa\xE7\xF5es de publicidade; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(c)'
                                ),
                                ' promo\xE7\xE3o de conte\xFAdo agregado; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(d)'
                                ),
                                ' contatar potenciais parceiros, entre outros.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Consentimento expresso do indiv\xEDduo\xB9.'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Dados para Servi\xE7o de Suporte'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'S\xE3o dados pessoais coletados para presta\xE7\xE3o de servi\xE7o de Suporte pela Mercos, sendo eles: ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(a)'
                                ),
                                ' e-mail; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' nome completo; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(c)'
                                ),
                                ' cargo que ocupa em sua organiza\xE7\xE3o; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(d)'
                                ),
                                ' telefone comercial; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(e)'
                                ),
                                ' empresa em que trabalha;'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Centralizar a abertura de chamado para acionamento do time de Suporte da Mercos.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Execu\xE7\xE3o de Contrato'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Assinatura de Contratos'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'S\xE3o dados pessoais coletados atrav\xE9s de e-mail ou de formul\xE1rios do Mercos, sendo eles: ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(a)'
                                ),
                                ' e-mail; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' nome completo; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(c)'
                                ),
                                ' CPF;'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Assinar Contratos e Termos aditivos com Clientes, Prestadores de Servi\xE7o e Fornecedores'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Execu\xE7\xE3o de Contrato'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Recursos de IA'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'S\xE3o dados pessoais coletados atrav\xE9s das intera\xE7\xF5es com as Recursos de Intelig\xEAncia Artificial, incluindo: ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(a)'
                                ),
                                ' conte\xFAdo das mensagens e comandos enviados pelo usu\xE1rio; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' de clientes e terceiros mencionados nas intera\xE7\xF5es; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(b)'
                                ),
                                ' identifica\xE7\xE3o do usu\xE1rio solicitante; ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '(c)'
                                ),
                                ' metadados da intera\xE7\xE3o (data, hora, canal).'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Processar as solicita\xE7\xF5es do usu\xE1rio no Servi\xE7o, executar a\xE7\xF5es operacionais (consultas, pedidos, tarefas), aprimorar a qualidade e precis\xE3o das Funcionalidades de IA, e garantir a seguran\xE7a e rastreabilidade das opera\xE7\xF5es realizadas.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Execu\xE7\xE3o contratual'
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                { className: 'tableHeader' },
                                'Extens\xF5es e integra\xE7\xF5es'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Dados necess\xE1rios ao funcionamento de extens\xF5es de navegador e integra\xE7\xF5es disponibilizadas pela Mercos em plataformas utilizadas pelo usu\xE1rio.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Permitir funcionalidades integradas da plataforma Mercos e facilitar a utiliza\xE7\xE3o do software.'
                            ),
                            _react2.default.createElement(
                                'td',
                                { className: 'tableData' },
                                'Execu\xE7\xE3o contratual.'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'small',
                        null,
                        '1. O consentimento \xE9 coletado no momento do primeiro acesso do usu\xE1rio ao software da Mercos, ou via solicita\xE7\xF5es claras e espec\xEDficas. Caso qualquer indiv\xEDduo opte por n\xE3o dar seu consentimento, a coleta de dados n\xE3o ocorrer\xE1.'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'small',
                        null,
                        '2. Com os dados coletados por sistemas terceiros, atrav\xE9s de cookies ou qualquer recurso de segmenta\xE7\xE3o e acompanhamento, a Mercos utiliza o recurso chamado remarketing, ou retargeting, para mostrar an\xFAncios com base nos assuntos, interesses e p\xE1ginas que s\xE3o visitadas dentro de seus sites. A Mercos n\xE3o usar\xE1 esse recurso para divulga\xE7\xE3o de servi\xE7os de terceiros como afiliado ou como qualquer outro tipo de promo\xE7\xE3o.'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'small',
                        null,
                        '3. Ressalta-se que todos os e-mails de marketing enviados pela Mercos possuem um link para cancelamento de inscri\xE7\xE3o caso o receptor n\xE3o deseje receber mais mensagens deste tipo.'
                    )
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '3. PARTILHA DE DADOS PESSOAIS'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Ao concordar com a coleta e o armazenamento de dados, em qualquer das formas descritas acima, os indiv\xEDduos tamb\xE9m entendem que a Mercos poder\xE1 compartilhar ditos dados com determinados terceiros, conforme abaixo:'
                ),
                _react2.default.createElement(
                    _Lists.UnorderedList,
                    null,
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Sucess\xE3o empresarial, a exemplo de fus\xE3o, aquisi\xE7\xE3o e incorpora\xE7\xE3o;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Contrata\xE7\xE3o de servi\xE7os de processamento de dados junto a terceiros (operadores), tais como hospedagem de dados, sistemas de processamento (servi\xE7os de computa\xE7\xE3o em nuvem), e consultoria em tecnologia da informa\xE7\xE3o (suporte presencial ou remoto);'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Servi\xE7os de publicidade e marketing (ferramentas que operam sobre controle da ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Mercos'
                        ),
                        '), organiza\xE7\xE3o de eventos (quando voc\xEA se interessar em participar de algum de nossos eventos presenciais ou online), servi\xE7os de faturamento de cr\xE9ditos (quando precisamos cobrar algum valor);'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Para possibilitar a integra\xE7\xE3o de servi\xE7os ou funcionalidades de terceiros contratados ou aceitos diretamente pelos Clientes da ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Mercos'
                        ),
                        '. Nesse caso, recomendamos que o cliente se atente para as pol\xEDticas e procedimentos de seguran\xE7a da informa\xE7\xE3o e prote\xE7\xE3o de dados do terceiro antes de promover a contrata\xE7\xE3o.'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Provedores de servi\xE7os de intelig\xEAncia artificial utilizados para o processamento de linguagem natural, exclusivamente para fins de interpreta\xE7\xE3o e execu\xE7\xE3o das solicita\xE7\xF5es do usu\xE1rio, observadas as medidas de seguran\xE7a e os limites estabelecidos neste Aviso e no T&C da Mercos.'
                    )
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Al\xE9m disso, em caso de exig\xEAncia judicial, a ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ' poder\xE1 compartilhar os dados de um titular com \xF3rg\xE3os reguladores, autoridades judiciais e administrativas. A disponibiliza\xE7\xE3o destes dados se dar\xE1 apenas mediante valida\xE7\xE3o da ordem emitida junto aos \xF3rg\xE3os competentes.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '4. CONSERVA\xC7\xC3O E ELIMINA\xC7\xC3O DE DADOS'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'A Mercos conserva todos os dados pessoais que coleta enquanto for necess\xE1rio para prestar os servi\xE7os que disponibiliza aos seus clientes e para fins comerciais leg\xEDtimos e essenciais, tais como para manter o desempenho de seu software, tomar decis\xF5es empresariais acerca de funcionalidades e ofertas com base em dados, cumprir suas obriga\xE7\xF5es legais, e resolver disputas.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'A pedido do titular dos dados (conforme determinado na se\xE7\xE3o 7) a Mercos eliminar\xE1 ou tornar\xE1 an\xF4nimo os dados pessoais do mesmo, de modo que n\xE3o o identifiquem, exceto nos casos onde for legalmente permitido \xE0 Mercos ou obrigat\xF3rio manter determinados dados pessoais, incluindo situa\xE7\xF5es como as seguintes:'
                ),
                _react2.default.createElement(
                    _Lists.OrderedList,
                    null,
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Nos casos de exist\xEAncia de qualquer problema relativo ao indiv\xEDduo, como um cr\xE9dito pendente de pagamento ou uma reclama\xE7\xE3o ou disputa n\xE3o resolvida, a Mercos ir\xE1 reter os dados pessoais necess\xE1rios at\xE9 que o problema seja resolvido;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Se a Mercos for obrigada a manter os dados pessoais para cumprir com suas obriga\xE7\xF5es legais, fiscais, de auditoria e contabilidade, ir\xE1 reter os dados pessoais necess\xE1rios pelo per\xEDodo exigido pela legisla\xE7\xE3o aplic\xE1vel;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Sempre que necess\xE1rio para os leg\xEDtimos interesses comerciais da Mercos, como a preven\xE7\xE3o contra fraudes ou para manter a seguran\xE7a dos seus usu\xE1rios.'
                    )
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '5. TRANSFER\xCANCIAS INTERNACIONAIS DE DADOS'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Os provedores de servi\xE7os utilizados pela ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ' podem estar localizados fora do territ\xF3rio brasileiro. No entanto, adotamos medidas apropriadas para garantir a prote\xE7\xE3o de seus dados, de acordo com a legisla\xE7\xE3o de prote\xE7\xE3o de dados aplic\xE1vel.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    '\xC9 importante ressaltar que, em certas circunst\xE2ncias, o consentimento para o fornecimento de informa\xE7\xF5es \xE0s autoridades competentes pode n\xE3o ser necess\xE1rio, quando tal divulga\xE7\xE3o \xE9 exigida por lei.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '6. COOKIES E TECNOLOGIAS SIMILARES'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Na utiliza\xE7\xE3o dos servi\xE7os da ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ' \xE9 poss\xEDvel que sejam coletadas informa\xE7\xF5es para a devida execu\xE7\xE3o dos servi\xE7os contratados, com o intuito de promover melhorias cont\xEDnuas na aplica\xE7\xE3o e aprimorar a experi\xEAncia do usu\xE1rio em suas plataformas e website.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Essa coleta de informa\xE7\xF5es \xE9 realizada em conformidade com as disposi\xE7\xF5es legais aplic\xE1veis, respeitando-se os princ\xEDpios de transpar\xEAncia, necessidade, proporcionalidade e finalidade previstos na legisla\xE7\xE3o de prote\xE7\xE3o de dados.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Para mais informa\xE7\xF5es, acesse a nossa Pol\xEDtica de Cookies, ',
                    _react2.default.createElement(
                        'a',
                        { href: 'https://mercos.com/documentos/politica-de-cookies.pdf', target: '_blank', rel: 'noreferrer' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            'dispon\xEDvel aqui'
                        )
                    ),
                    '.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '7. DIREITOS DO TITULAR DE DADOS'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'A ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ' garante a voc\xEA seus direitos conforme a legisla\xE7\xE3o pertinente, permitindo que o titular tenha acesso \xE0s suas informa\xE7\xF5es a qualquer momento e mediante requisi\xE7\xE3o:'
                ),
                _react2.default.createElement(
                    _Lists.UnorderedList,
                    null,
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Solicitar e confirmar o acesso aos seus dados e tratamento dos mesmos;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Solicitar a altera\xE7\xE3o ou corre\xE7\xE3o de seus dados;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Solicitar a anonimiza\xE7\xE3o, bloqueio ou elimina\xE7\xE3o de dados desnecess\xE1rios;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Solicitar a transfer\xEAncia de seus dados;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Solicitar a elimina\xE7\xE3o de seus dados, em ressalva a proibitiva legal;'
                    ),
                    _react2.default.createElement(
                        _Lists.ListItem,
                        null,
                        'Solicitar informa\xE7\xF5es sobre compartilhamento de dados com terceiros.'
                    )
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Toda solicita\xE7\xE3o ser\xE1 analisada e ser\xE1 considerada com base no tratamento legal, de modo que o atendimento possa ocorrer de maneira parcial ou at\xE9 negativa, al\xE9m disso poder\xE1 ser solicitado documentos complementares visando \xE0 n\xE3o divulga\xE7\xE3o de dados pessoais a pessoas n\xE3o autorizadas.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Caso o titular de dados queira exercer qualquer um de seus direitos expressos na Lei, bem como tirar d\xFAvidas referentes a esta documenta\xE7\xE3o, basta clicar no Selo \u201CDados Pessoais Protegidos\u201D em nosso site e preencher o \u201CFormul\xE1rio de Atendimento ao Titular de Dados\u201D.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Por meio do Selo, qualquer interessado \xE9 direcionado ao Portal Privacidade & Voc\xEA e pode verificar a autenticidade da adequa\xE7\xE3o da ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ' \xE0 LGPD.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '8. ISEN\xC7\xC3O DE RESPONSABILIDADES'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'A ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ' n\xE3o se responsabiliza pela neglig\xEAncia do usu\xE1rio com seus pr\xF3prios dados pessoais. A responsabilidade da ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ' se limita aos esfor\xE7os sobre a garantia do emprego das melhores pr\xE1ticas de seguran\xE7a.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Cabe ao usu\xE1rio zelar pela confidencialidade de informa\xE7\xF5es relacionadas ao acesso e opera\xE7\xE3o de seus dados no sistema, plataforma e website da ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ', tais como informa\xE7\xF5es de login, senha, chaves de seguran\xE7a e qualquer outra solu\xE7\xE3o de seguran\xE7a implementada pela Declarante.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '9. REVIS\xC3O DO AVISO DE PRIVACIDADE'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'A ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Mercos'
                    ),
                    ' se reserva no direito de atualizar o nosso Aviso de Privacidade quantas vezes forem necess\xE1rias, a fim de fornecer a voc\xEA informa\xE7\xF5es mais seguras e melhorar cada vez mais a sua experi\xEAncia.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '10. LEGISLA\xC7\xC3O APLIC\xC1VEL'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Nosso aviso de privacidade est\xE1 em conformidade com as leis e atos normativos que comp\xF5em o ordenamento jur\xEDdico brasileiro. Fica eleito o Foro da Comarca de de Joinville, estado de Santa Catarina, como o competente para dirimir eventuais quest\xF5es oriundas do presente documento, com expressa ren\xFAncia a qualquer outro.'
                )
            ),
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    _Heading4.default,
                    null,
                    '11. CONTATO'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'O DPOnet, inscrito no CNPJ sob o n\xBA 36.487.128/0001-79, foi nomeado como nosso Encarregado de Dados. Assim, ele est\xE1 apto a exercer todas as fun\xE7\xF5es e atribui\xE7\xF5es do cargo, previstas na LGPD.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    'Caso voc\xEA deseje exercer qualquer um de seus direitos, expressos na LGPD, basta clicar no ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Selo \u201CDados Pessoais Protegidos\u201D, em nosso site'
                    ),
                    ', e preencher o \u201CFormul\xE1rio de Atendimento ao Titular de Dados\u201D ou entrar em contato via e-mail no ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'privacidade@mercos.com'
                    ),
                    '.'
                ),
                _react2.default.createElement(
                    _Paragraph2.default,
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: 'https://mercos.com/documentos/aviso-de-privacidade.pdf', target: '_blank', rel: 'noreferrer' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Fazer download do documento'
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(_NewFooterV2.default, null)
    );
});

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webpSrc = _ref.webpSrc,
        mobileSrc = _ref.mobileSrc,
        alt = _ref.alt,
        className = _ref.className,
        desktop = _ref.desktop,
        mobile = _ref.mobile,
        noWebp = _ref.noWebp,
        fetchPriority = _ref.fetchPriority,
        width = _ref.width,
        height = _ref.height,
        style = _ref.style,
        loading = _ref.loading,
        onLoad = _ref.onLoad,
        srcSet = _ref.srcSet,
        sizes = _ref.sizes,
        decoding = _ref.decoding,
        imgProps = _objectWithoutProperties(_ref, ['src', 'webpSrc', 'mobileSrc', 'alt', 'className', 'desktop', 'mobile', 'noWebp', 'fetchPriority', 'width', 'height', 'style', 'loading', 'onLoad', 'srcSet', 'sizes', 'decoding']);

    // Detect external URLs - if src starts with http:// or https://, it's external
    var isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
    // Skip WebP for external URLs or when noWebp prop is explicitly set
    var shouldSkipWebp = noWebp || isExternal;

    var extension = src.split('.').pop();
    var isSvg = extension.toLowerCase() === 'svg';
    var webpSource = webpSrc || src.replace('.' + extension, '.webp');
    var desktopClass = desktop ? 'desktop-only' : '';
    var mobileClass = mobile ? 'mobile-only' : '';
    var loadingValue = loading || (fetchPriority ? "eager" : "lazy");

    // Common img props to pass through
    var commonImgProps = _extends({
        className: className + ' ' + desktopClass + ' ' + mobileClass,
        src: '' + src,
        alt: '' + alt,
        loading: loadingValue,
        width: width,
        height: height,
        style: style,
        onLoad: onLoad,
        srcSet: srcSet,
        sizes: sizes,
        decoding: decoding,
        fetchpriority: fetchPriority }, imgProps);

    // For SVG files, just return a simple img tag without picture/source elements
    if (isSvg) {
        return _react2.default.createElement('img', commonImgProps);
    }

    return _react2.default.createElement(
        'picture',
        null,
        mobileSrc && _react2.default.createElement(
            _react.Fragment,
            null,
            !shouldSkipWebp && _react2.default.createElement('source', {
                srcSet: webpSource + ', ' + mobileSrc.replace('.' + extension, '.webp') + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/webp'
            }),
            _react2.default.createElement('source', {
                srcSet: src + ', ' + mobileSrc + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/' + extension
            })
        ),
        !shouldSkipWebp && _react2.default.createElement('source', { srcSet: '' + webpSource, type: 'image/webp' }),
        _react2.default.createElement('img', commonImgProps)
    );
};

exports.default = Picture;

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	var gad_campaignid = _jsCookie2.default.get('madscampaignid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		params += gad_campaignid ? '&gad_campaignid=' + gad_campaignid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(538);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = function Paragraph(_ref) {
    var center = _ref.center,
        children = _ref.children,
        className = _ref.className,
        gray = _ref.gray,
        italic = _ref.italic,
        left = _ref.left,
        _onClick = _ref.onClick,
        small = _ref.small,
        white = _ref.white;
    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)('paragraph', className, center && 'text-center', gray && 'heading-gray', italic && 'italic', left && 'text-left', small && 'small', white && 'heading-white'),
            onClick: function onClick(e) {
                return _onClick ? _onClick(e) : null;
            } },
        children
    );
};

exports.default = Paragraph;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(545);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var accessLinks = [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }];

    var footerRows = [[{
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/' }, { name: 'CRM', url: '/crm-de-vendas' }, { name: 'Mercos Pay', url: '/mercos-pay' }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Recursos',
        links: [{ name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Indicadores de vendas', url: '/recursos/indicadores-performance/' }, { name: 'Políticas comerciais', url: '/recursos/politica-comercial-vendas/' }, { name: 'Mercos IA', url: '/recursos/mercos-ia/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/', external: true }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI', external: true }, { name: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                'E-commerce B2B: O',
                _react2.default.createElement('br', null),
                'que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank', external: true }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank', external: true }, { name: 'Relatório da igualdade salarial', url: '/relatorio-igualdade-salarial/' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', external: true }, {
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }], [{
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Planos e preços',
        links: [{ name: 'Indústrias e distribuidoras', url: '/planos-e-precos/industrias-e-distribuidoras/' }, { name: 'Representantes', url: '/planos-e-precos/representantes/' }]
    }, {
        title: 'Institucional',
        links: [{ name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Integrações',
        links: [{ name: 'ERPs integrados', url: '/integracao-erp/' }, { name: 'Seja Parceiro', url: '/parceiros' }, { name: 'Documentação da API', url: 'https://docs.mercos.com/', external: true }]
    }, {
        title: 'Baixe o aplicativo',
        content: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'app-buttons' },
                _react2.default.createElement(
                    'a',
                    { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'app-downloads' },
                _react2.default.createElement(
                    'strong',
                    null,
                    '+100 mil'
                ),
                ' downloads'
            )
        )
    }]];

    var renderLink = function renderLink(link) {
        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'footer-link';

        if (link.custom) return link.content;
        var target = link.target || (link.external ? '_blank' : null);

        return _react2.default.createElement(
            'a',
            {
                className: className,
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: target,
                rel: target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name,
            link.external && _react2.default.createElement(
                'span',
                { className: 'material-icons site-footer__external-icon', 'aria-hidden': 'true' },
                'north_east'
            )
        );
    };

    var socialLinks = [{ name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer site-footer', 'aria-label': 'Rodap\xE9' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content site-footer__inner' },
            _react2.default.createElement(
                'div',
                { className: 'site-footer__access' },
                _react2.default.createElement(
                    'p',
                    { className: 'site-footer__access-txt' },
                    'J\xE1 \xE9 cliente ou quer come\xE7ar?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-footer__access-actions' },
                    accessLinks.map(function (link, index) {
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: link.url },
                            renderLink(link, 'site-footer__access-btn site-footer__access-btn--' + (index === 0 ? 'login' : 'signup'))
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'nav',
                { className: 'footer-main site-footer__nav', 'aria-label': 'Links do rodap\xE9' },
                footerRows.map(function (row, rowIndex) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'site-footer__nav-row', key: rowIndex },
                        row.map(function (section) {
                            return _react2.default.createElement(
                                'section',
                                { className: 'footer-section site-footer__section', key: section.title },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'section-title site-footer__col-title' },
                                    section.title
                                ),
                                section.content || _react2.default.createElement(
                                    'div',
                                    { className: 'section-links site-footer__links' },
                                    section.links.map(function (link, linkIndex) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'link-item', key: link.url || linkIndex },
                                            renderLink(link, 'footer-link site-footer__link')
                                        );
                                    })
                                )
                            );
                        })
                    );
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'footer-bottom site-footer__bar' },
            _react2.default.createElement(
                'div',
                { className: 'footer-container site-footer__bar-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'logo-container' },
                    _react2.default.createElement(
                        'a',
                        { href: '/', className: 'mercos-logo site-footer__bar-logo-link' },
                        _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'company-info site-footer__legal' },
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA9 ',
                        new Date().getFullYear(),
                        ' Simplest Software Ltda. Todos os direitos reservados.'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        'CNPJ: 12.496.510/0001-80 \xB7 Av. Rolf Wiest, 277 (4\xBA andar) \xB7 Bom Retiro \u2014 Joinville/SC \xB7 CEP: 89223-005'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'social-links site-footer__social' },
                    socialLinks.map(function (social) {
                        return _react2.default.createElement(
                            'a',
                            {
                                key: social.name,
                                href: social.url,
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                className: 'social-link site-footer__social-link',
                                'aria-label': social.name
                            },
                            _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: social.icon, alt: 'Mercos no ' + social.name })
                        );
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'feito-com-amor site-footer__made' },
                        'Feito com \uD83D\uDC9C'
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
        'aria-label': ariaLabel,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        onChange: onChange,
        placeholder: placeholder,
        type: type,
        value: value,
        name: name || id
    });
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

__webpack_require__(548);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _siteNavData = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderItemTitle = function renderItemTitle(title) {
  if (typeof title === 'string') {
    return _react2.default.createElement(
      'h4',
      null,
      title
    );
  }
  return _react2.default.createElement(
    'h4',
    null,
    title
  );
};

var SiteNav = function SiteNav(_ref) {
  var _ref$hideOnScroll = _ref.hideOnScroll,
      hideOnScroll = _ref$hideOnScroll === undefined ? false : _ref$hideOnScroll,
      _ref$menuVisible = _ref.menuVisible,
      menuVisible = _ref$menuVisible === undefined ? true : _ref$menuVisible,
      _ref$pixelsToShowMenu = _ref.pixelsToShowMenuWhite,
      pixelsToShowMenuWhite = _ref$pixelsToShowMenu === undefined ? 50 : _ref$pixelsToShowMenu,
      _ref$transparentOnTop = _ref.transparentOnTop,
      transparentOnTop = _ref$transparentOnTop === undefined ? false : _ref$transparentOnTop,
      _ref$whiteBackground = _ref.whiteBackground,
      whiteBackground = _ref$whiteBackground === undefined ? false : _ref$whiteBackground,
      _ref$promoBarHeight = _ref.promoBarHeight,
      promoBarHeight = _ref$promoBarHeight === undefined ? 0 : _ref$promoBarHeight,
      _ref$loginOnly = _ref.loginOnly,
      loginOnly = _ref$loginOnly === undefined ? false : _ref$loginOnly,
      _ref$logoOnly = _ref.logoOnly,
      logoOnly = _ref$logoOnly === undefined ? false : _ref$logoOnly;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isAtTop = _useState4[0],
      setIsAtTop = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileMenuOpen = _useState6[0],
      setMobileMenuOpen = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileOpenSections = _useState8[0],
      setMobileOpenSections = _useState8[1];

  var closeTimerRef = (0, _react.useRef)(null);
  var dropdownRefs = (0, _react.useRef)([]);

  var showTransparentTop = transparentOnTop && isAtTop && !whiteBackground && !mobileMenuOpen;

  var closeMobileMenu = (0, _react.useCallback)(function () {
    setMobileMenuOpen(false);
    setMobileOpenSections({});
  }, []);

  var toggleMobileMenu = function toggleMobileMenu() {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      setMobileMenuOpen(true);
    }
  };

  var toggleMobileSection = function toggleMobileSection(index) {
    setMobileOpenSections(function (prev) {
      return _extends({}, prev, _defineProperty({}, index, !prev[index]));
    });
  };

  var closeAllDropdowns = function closeAllDropdowns() {
    return setActiveMenu(null);
  };

  var handleNavItemEnter = function handleNavItemEnter(index) {
    clearTimeout(closeTimerRef.current);
    setActiveMenu(index);

    var dd = dropdownRefs.current[index];
    if (!dd) return;

    dd.style.left = '';
    dd.style.right = '';

    requestAnimationFrame(function () {
      var rect = dd.getBoundingClientRect();
      var vw = window.innerWidth;
      if (rect.right > vw - 8) {
        var overflow = rect.right - (vw - 8);
        var currentLeft = parseFloat(window.getComputedStyle(dd).left) || 0;
        if (dd.style.right === '') {
          dd.style.left = currentLeft - overflow + 'px';
        }
      }
      if (rect.left < 8) {
        dd.style.left = '0px';
      }
    });
  };

  var handleNavItemLeave = function handleNavItemLeave(index) {
    closeTimerRef.current = setTimeout(function () {
      setActiveMenu(function (current) {
        return current === index ? null : current;
      });
    }, 100);
  };

  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsAtTop(scrollTop <= pixelsToShowMenuWhite);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pixelsToShowMenuWhite]);

  (0, _react.useEffect)(function () {
    document.body.classList.toggle('mobile-menu-is-open', mobileMenuOpen);
    if (!mobileMenuOpen) {
      return undefined;
    }

    var onKeyDown = function onKeyDown(event) {
      if (event.key === 'Escape') {
        closeMobileMenu();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.body.classList.remove('mobile-menu-is-open');
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileMenuOpen, closeMobileMenu]);

  (0, _react.useEffect)(function () {
    var onDocumentClick = function onDocumentClick(event) {
      if (!event.target.closest('.site-nav__item')) {
        closeAllDropdowns();
      }
    };

    var onEscape = function onEscape(event) {
      if (event.key === 'Escape') {
        closeAllDropdowns();
      }
    };

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onEscape);

    return function () {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onEscape);
      clearTimeout(closeTimerRef.current);
    };
  }, []);

  var navClassName = ['site-nav', hideOnScroll ? 'hide-on-scroll' : '', hideOnScroll && !menuVisible ? 'menu-hidden' : 'menu-visible', showTransparentTop ? 'at-top' : 'scrolled', promoBarHeight > 0 ? 'has-promo-bar' : '', mobileMenuOpen ? 'mobile-open' : '', logoOnly ? 'logo-only' : ''].filter(Boolean).join(' ');

  var menuItems = loginOnly ? [] : _siteNavData.siteNavData;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' })
    ),
    _react2.default.createElement(
      'header',
      { className: navClassName, id: 'siteHeader' },
      _react2.default.createElement(
        'a',
        { href: '/', className: 'site-nav__logo', 'aria-label': 'Mercos' },
        _react2.default.createElement(_Picture2.default, {
          src: '/images/site/logo-mercos-colored.svg',
          alt: 'Mercos',
          className: 'site-nav__logo-img'
        })
      ),
      !loginOnly && !logoOnly && _react2.default.createElement(
        'nav',
        { className: 'site-nav__desktop', 'aria-label': 'Navega\xE7\xE3o principal' },
        _react2.default.createElement(
          'ul',
          { className: 'site-nav__menu' },
          menuItems.map(function (menuItem, idx) {
            return _react2.default.createElement(
              'li',
              {
                key: menuItem.label,
                className: 'site-nav__item' + (activeMenu === idx ? ' open' : ''),
                onMouseEnter: function onMouseEnter() {
                  return handleNavItemEnter(idx);
                },
                onMouseLeave: function onMouseLeave() {
                  return handleNavItemLeave(idx);
                }
              },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'site-nav__trigger',
                  'aria-haspopup': 'true',
                  'aria-expanded': activeMenu === idx
                },
                menuItem.label
              ),
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(el) {
                    dropdownRefs.current[idx] = el;
                  },
                  className: 'site-nav__dropdown' + (menuItem.grid ? ' site-nav__dropdown--grid' : ''),
                  role: 'menu'
                },
                menuItem.items.map(function (item, subIdx) {
                  if (item.type === 'separator') {
                    return _react2.default.createElement(
                      'div',
                      { key: item.label + '-' + subIdx, className: 'site-nav__dd-label' },
                      item.label
                    );
                  }

                  return _react2.default.createElement(
                    'a',
                    {
                      key: item.link + '-' + subIdx,
                      href: item.link,
                      className: 'site-nav__dd-item',
                      role: 'menuitem',
                      target: item.target,
                      rel: item.target === '_blank' ? 'noopener noreferrer' : undefined
                    },
                    _react2.default.createElement(
                      'span',
                      { className: 'material-icons site-nav__dd-icon' },
                      item.icon
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'site-nav__dd-text' },
                      renderItemTitle(item.title),
                      item.description ? _react2.default.createElement(
                        'p',
                        null,
                        item.description
                      ) : null
                    )
                  );
                })
              )
            );
          })
        )
      ),
      !logoOnly && _react2.default.createElement(
        'div',
        { className: 'site-nav__actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__mobile-cta',
          onClick: function onClick() {
            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
          }
        },
        'comece gr\xE1tis'
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__hamburger' + (mobileMenuOpen ? ' active' : ''),
          id: 'headerHamburger',
          'aria-label': mobileMenuOpen ? 'Fechar menu' : 'Abrir menu',
          'aria-expanded': mobileMenuOpen,
          'aria-controls': 'mobileNav',
          onClick: toggleMobileMenu
        },
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null)
      )
    ),
    !logoOnly && _react2.default.createElement(
      'nav',
      {
        className: 'site-nav__mobile' + (mobileMenuOpen ? ' active' : ''),
        id: 'mobileNav',
        'aria-label': 'Menu mobile',
        'aria-hidden': !mobileMenuOpen
      },
      menuItems.map(function (menuItem, idx) {
        return _react2.default.createElement(
          'div',
          {
            key: menuItem.label,
            className: 'site-nav__mob-section' + (mobileOpenSections[idx] ? ' open' : '')
          },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'site-nav__mob-toggle',
              onClick: function onClick() {
                return toggleMobileSection(idx);
              }
            },
            menuItem.label,
            _react2.default.createElement(
              'span',
              { className: 'material-icons' },
              'expand_more'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'site-nav__mob-items' },
            _react2.default.createElement(
              'div',
              { className: 'site-nav__mob-items-inner' },
              menuItem.items.map(function (item, subIdx) {
                if (item.type === 'separator') {
                  return _react2.default.createElement(
                    'div',
                    { key: item.label + '-' + subIdx, className: 'site-nav__mob-label' },
                    item.label
                  );
                }

                return _react2.default.createElement(
                  'a',
                  {
                    key: item.link + '-' + subIdx,
                    href: item.link,
                    className: 'site-nav__mob-item',
                    target: item.target,
                    rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
                    onClick: closeMobileMenu
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'material-icons' },
                    item.icon
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    renderItemTitle(item.title),
                    item.description ? _react2.default.createElement(
                      'p',
                      null,
                      item.description
                    ) : null
                  )
                );
              })
            )
          )
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'site-nav__mob-actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      )
    )
  );
};

exports.default = SiteNav;

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteNavData = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteNavData = exports.siteNavData = [{
  label: 'Soluções',
  items: [{
    title: 'Força de vendas',
    description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
    icon: 'bar_chart',
    link: '/forca-vendas/'
  }, {
    title: 'E-commerce B2B',
    description: 'Venda 24h por dia com a loja online de empresas para empresas',
    icon: 'shopping_cart',
    link: '/e-commerce-b2b'
  }, {
    type: 'separator',
    label: 'Outras Soluções'
  }, {
    title: 'CRM',
    description: 'Cuide da prospecção ao pós-venda dos clientes em um só lugar',
    icon: 'filter_alt',
    link: '/crm-de-vendas'
  }, {
    title: 'Mercos Pay',
    description: 'Receba pagamentos por pix, boleto e cartões de crédito',
    icon: 'credit_card',
    link: '/mercos-pay'
  }, {
    title: 'Videochamada',
    description: 'Venda por vídeo com experiência de visita presencial',
    icon: 'videocam',
    link: '/videochamada'
  }]
}, {
  label: 'Segmentos',
  items: [{
    title: 'Indústrias',
    description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
    icon: 'factory',
    link: '/sistema-para-industria/'
  }, {
    title: 'Distribuidoras',
    description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
    icon: 'home_work',
    link: '/sistema-distribuidora/'
  }, {
    title: 'Representantes',
    description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
    icon: 'work',
    link: '/sistema-representante/'
  }]
}, {
  label: 'Planos e preços',
  items: [{
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Ind\xFAstrias e distribuidoras'
      )
    ),
    description: '',
    icon: 'factory',
    link: '/planos-e-precos/industrias-e-distribuidoras/'
  }, {
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Representantes'
      )
    ),
    description: '',
    icon: 'work',
    link: '/planos-e-precos/representantes/'
  }]
}, {
  label: 'Integrações',
  items: [{
    title: 'ERPs integrados',
    description: '+250 ERPs parceiros integrados ao Força de vendas e E-commerce B2B',
    icon: 'device_hub',
    link: '/integracao-erp'
  }, {
    title: 'Seja Parceiro',
    description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
    icon: 'people',
    link: '/parceiros'
  }]
}, {
  label: 'Recursos',
  grid: true,
  items: [{
    title: 'Aplicativo de vendas',
    description: 'Emita pedidos até sem internet e agilize a rotina do seu time comercial.',
    icon: 'smartphone',
    link: '/recursos/aplicativo-vendas-externas/'
  }, {
    title: 'Mercos IA',
    description: 'Inteligência Artificial na palma da sua mão',
    icon: 'auto_awesome',
    link: '/recursos/mercos-ia/'
  }, {
    title: 'Indicadores de vendas',
    description: 'Visualize a performance do seu comercial em tempo real e tome decisões mais rápidas.',
    icon: 'show_chart',
    link: '/recursos/indicadores-performance/'
  }, {
    title: 'Materiais ricos',
    description: 'Ebooks e guias para turbinar sua estratégia de vendas B2B.',
    icon: 'menu_book',
    link: '/materiais/'
  }, {
    title: 'Políticas comerciais',
    description: 'Aplique regras de preço, desconto e acréscimo sem erro – tudo de forma automática.',
    icon: 'flag',
    link: '/recursos/politica-comercial-vendas/'
  }, {
    title: 'Cases',
    description: 'Veja cases de sucesso e inspire melhores resultados para sua empresa.',
    icon: 'rocket_launch',
    link: 'https://mercos.com/cases/'
  }]
}];

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = function ButtonLink(_ref) {
    var children = _ref.children,
        color = _ref.color,
        model = _ref.model,
        size = _ref.size,
        radius = _ref.radius,
        className = _ref.className,
        _ref$href = _ref.href,
        href = _ref$href === undefined ? '/' : _ref$href,
        target = _ref.target,
        rel = _ref.rel,
        title = _ref.title,
        onClick = _ref.onClick,
        style = _ref.style,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        shake = _ref.shake;
    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('button', model, size, radius, className, color, shake && 'shake'),
            href: href,
            target: target,
            title: title,
            onClick: onClick,
            style: style,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            rel: rel ? rel : target === '_blank' ? 'noopener noreferrer' : '' },
        children
    );
};

ButtonLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.any,
    color: _propTypes2.default.string,
    href: _propTypes2.default.string,
    model: _propTypes2.default.oneOf(['outline', 'secondary', 'success', 'alert', 'warning']),
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded']),
    size: _propTypes2.default.string,
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    title: _propTypes2.default.string
};

exports.default = ButtonLink;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading4 = function Heading4(_ref) {
    var children = _ref.children,
        center = _ref.center,
        white = _ref.white,
        gray = _ref.gray,
        bottomSpace = _ref.bottomSpace,
        className = _ref.className;
    return _react2.default.createElement(
        'h4',
        { className: (0, _classnames2.default)('heading4', className, center ? 'text-center' : '', white ? 'heading-white' : '', gray ? 'heading-gray' : '', bottomSpace ? 'bottom-space' : '') },
        children
    );
};

exports.default = Heading4;

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Component) {
    _inherits(Link, _Component);

    function Link(props) {
        _classCallCheck(this, Link);

        var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

        _this.state = {
            isActive: false
        };
        return _this;
    }

    _createClass(Link, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                isActive: window.location.href === window.location.pathname + window.location.hash ? 'active' : false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'a',
                { className: (0, _classnames2.default)('link', this.props.arrow && 'arrow', this.props.className, this.props.color, this.props.model, this.props.weight, this.state.isActive),
                    href: !this.state.isActive ? this.props.href : undefined,
                    onClick: this.props.onClick,
                    onMouseOver: this.props.onMouseOver,
                    target: this.props.target,
                    title: this.props.title,
                    rel: this.props.rel ? this.props.rel : this.props.target === '_blank' ? 'noopener noreferrer' : '',
                    ref: this.props.linkRef },
                this.props.children
            );
        }
    }]);

    return Link;
}(_react.Component);

Link.defaultProps = {
    color: 'linkDark',
    model: 'initial-underline',
    weight: 'medium'
};

Link.propTypes = {
    color: _propTypes2.default.oneOf(['linkDark', 'linkLight', 'green', 'white', 'linkBlack']),
    model: _propTypes2.default.oneOf(['initial-underline', 'hover-underline']),
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    weight: _propTypes2.default.oneOf(['thin', 'extra-light', 'light', 'regular', 'medium', 'semi-bold', 'bold', 'extra-bold', 'black'])
};

exports.default = Link;

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading1 = function Heading1(_ref) {
    var children = _ref.children,
        white = _ref.white,
        center = _ref.center,
        className = _ref.className,
        left = _ref.left,
        style = _ref.style,
        purple = _ref.purple,
        black = _ref.black;
    return _react2.default.createElement(
        'h1',
        { style: style,
            className: (0, _classnames2.default)('heading1', className, white && 'heading-white', center && 'text-center', left && 'text-left', purple && 'heading-purple', black && 'heading-black') },
        children
    );
};

exports.default = Heading1;

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _ButtonLink = __webpack_require__(557);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(546);

var _Input2 = _interopRequireDefault(_Input);

var _Heading = __webpack_require__(560);

var _Heading2 = _interopRequireDefault(_Heading);

var _Paragraph = __webpack_require__(543);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'company', 'activeClients'];

var ACTIVITY = {
    erpSalesChannel: 'Canal de Vendas de ERP',
    erpManufacturer: 'Fabricante de ERP',
    integrator: 'Integrador'
};

var CLIENTS = {
    zero: '0%',
    upToTwenty: 'Entre 1% e 20%',
    upToFifty: 'Entre 21% e 50%',
    upToEighty: 'Entre 51% e 80%',
    upToHundred: 'Entre 81% e 100%'
};

var PartnerContactModal = function (_Component) {
    _inherits(PartnerContactModal, _Component);

    function PartnerContactModal(props) {
        _classCallCheck(this, PartnerContactModal);

        var _this = _possibleConstructorReturn(this, (PartnerContactModal.__proto__ || Object.getPrototypeOf(PartnerContactModal)).call(this, props));

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState();
        return _this;
    }

    _createClass(PartnerContactModal, [{
        key: 'getInitialState',
        value: function getInitialState() {
            var initialObject = {
                showDemoModal: false,
                showDemoForm: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                activeClients: '',
                clients: ''
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true,
                showDemoForm: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false,
                showDemoForm: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _setState;

            var name = e.target.id,
                value = e.target.value;

            if (name === 'telephone') {
                value = this.telephoneMask(value);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(type) {
            this.setState({ 'activity': type });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerClients',
        value: function handlerClients(type) {
            this.setState({ 'clients': type });
        }
    }, {
        key: 'getSelectedClients',
        value: function getSelectedClients(selected) {
            return this.state.clients === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this2 = this;

            var newState = {};
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var regexName = /^(.|\s)*\S(.|\s)*/;
            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;

            FIELDS.forEach(function (campo) {
                newState[campo + 'Error'] = !_this2.state[campo][('name', 'email', 'telephone', 'company', 'activeClients')];
                switch (campo) {
                    case 'email':
                        newState[campo + 'Error'] = !regexEmail.test(_this2.state[campo].toLowerCase());
                        break;
                    case 'name':
                        newState[campo + 'Error'] = !regexName.test(_this2.state[campo]);
                        break;
                    case 'telephone':
                        newState[campo + 'Error'] = !regexTelephone.test(_this2.state[campo]);
                        break;
                    case 'company':
                        newState[campo + 'Error'] = !_this2.state[campo].length > 0;
                        break;
                    case 'activeClients':
                        newState[campo + 'Error'] = !_this2.state[campo].length > 0;
                        break;
                }
            });

            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, "") : '',
                numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            var _this3 = this;

            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicitou-contato-parceiro',
                    'cf_tipo_de_conversao': 'Solicitou Contato Parceiro',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_clientes_ativos_canais': this.state.activeClients,
                    'cf_ramo_de_atuacao_canais': this.state.activity,
                    'cf_percentual_perfil_ind_dist_canais': this.state.clients
                };

                if (this.state.partnerId) {
                    data['conversion_identifier'] = 'canais-lp', data['cf_codigo_do_parceiro_meus_pedidos'] = this.props.partnerId;
                }

                this.rdGateway.sendToRDStation(data);

                this.setState({
                    showDemoForm: false
                });

                setTimeout(function () {
                    _this3.setState({
                        showDemoModal: false,
                        showDemoForm: true
                    });
                }, 3000);
            }
        }
    }, {
        key: 'componentDidMout',
        value: function componentDidMout() {
            this.setDataByCookie();
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this4 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this4.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container-form-modal', this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement(
                        _Heading2.default,
                        null,
                        'Quer ser um Mpartner?'
                    ),
                    _react2.default.createElement(
                        _Paragraph2.default,
                        null,
                        'Deixe seu contato e venha conquistar mercados com a gente.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '/', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                                return _this4.submitForm(e);
                            } },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'name' },
                            'Nome'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.nameError, autoFocus: true }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'email' },
                            'E-mail'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.emailError }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'telephone' },
                            'Telefone'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15' }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'company' },
                            'Empresa'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'company', value: this.state.company, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.companyError }),
                        _react2.default.createElement(
                            'label',
                            { style: {
                                    marginTop: '20px'
                                } },
                            'Qual \xE9 o ramo de atua\xE7\xE3o da sua empresa?'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'group-buttons' },
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.erpSalesChannel), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.erpSalesChannel);
                                    } },
                                'Canal de vendas de ERP'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.erpManufacturer), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.erpManufacturer);
                                    } },
                                'Fabricante - ERP'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.integrator), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.integrator);
                                    } },
                                'Integrador'
                            )
                        ),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'activeClients' },
                            'Quantos clientes ativos voc\xEA possui?'
                        ),
                        _react2.default.createElement(_Input2.default, { id: 'activeClients', value: this.state.activeClients, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.activeClientsError }),
                        _react2.default.createElement(
                            'label',
                            { style: {
                                    marginTop: '20px'
                                } },
                            'Quanto dos seus clientes correspondem a Ind\xFAstria ou Distribui\xE7\xE3o?'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'group-buttons' },
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.zero), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.zero);
                                    } },
                                '0%'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.upToTwenty), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.upToTwenty);
                                    } },
                                'At\xE9 20%'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.upToFifty), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.upToFifty);
                                    } },
                                'At\xE9 50%'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.upToEighty), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.upToEighty);
                                    } },
                                'At\xE9 80%'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedClients(CLIENTS.upToHundred), onClick: function onClick() {
                                        return _this4.handlerClients(CLIENTS.upToHundred);
                                    } },
                                '81% ou mais'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', radius: 'half-rounded' },
                                'Solicitar contato'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container-form-confirm', !this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement(_Picture2.default, { className: 'success-icon', src: '/images/success.png', alt: 'Solicita\xE7\xE3o enviada com sucesso!' }),
                    _react2.default.createElement(
                        'p',
                        { className: 'paragraph' },
                        'Sua solicita\xE7\xE3o foi enviada com sucesso!'
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var size = this.props.size,
                model = this.props.model;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    _ButtonLink2.default,
                    {
                        href: '#',
                        className: this.props.className,
                        onClick: function onClick(e) {
                            return _this5.openDemoModal(e);
                        },
                        model: model,
                        size: size,
                        title: 'Pe\xE7a um contato dos nossos especialistas.',
                        radius: 'half-rounded' },
                    'Seja nosso parceiro'
                ),
                this.state.showDemoModal && this.getDemoModal()
            );
        }
    }]);

    return PartnerContactModal;
}(_react.Component);

PartnerContactModal.propTypes = {
    className: _propTypes2.default.string
};

exports.default = PartnerContactModal;

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = __webpack_require__(561);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _MenuItem = __webpack_require__(609);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _PartnerContactModal = __webpack_require__(603);

var _PartnerContactModal2 = _interopRequireDefault(_PartnerContactModal);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Utm = __webpack_require__(532);

__webpack_require__(612);

var _SiteNav = __webpack_require__(547);

var _SiteNav2 = _interopRequireDefault(_SiteNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var softwareSubItems = [{
    href: '/industrias',
    title: 'Veja como o Mercos pode potencializar sua Indústria.',
    content: 'Indústrias',
    url: '/images/site/new-home/mercos-para-industrias.webp'
}, {
    href: '/distribuidoras',
    title: 'Veja como o Mercos pode potencializar sua Distribuidora.',
    content: 'Distribuidoras',
    url: '/images/site/new-home/mercos-para-distribuidoras.webp'
}, {
    href: '/representantes-comerciais',
    title: 'Veja como o Mercos pode potencializar o Representante Comercial.',
    content: 'Representantes',
    url: '/images/site/new-home/mercos-para-representantes-comerciais.webp'
}],
    partnersSubItems = [{
    href: '/integracao-erp',
    title: 'Encontre o ERP ideal com integração ao Mercos.',
    content: 'ERPs integrados'
}, {
    href: '/parceiros',
    title: 'Conheça nosso programa de Parceiros.',
    content: 'Seja parceiro'
}],
    conteudoSubItems = [{
    href: 'https://blog.mercos.com/',
    title: 'Novidades no blog',
    content: 'Blog',
    target: '_blank'
}, {
    href: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI',
    title: 'Mercoscast',
    content: 'Mercoscast',
    target: '_blank'
}],
    participantsSubItems = [{
    href: '/experience/ingressos',
    title: 'Comprar agora meu ingresso.',
    content: 'Ingressos'
}, {
    href: '/experience/onde-ficar',
    title: 'Saiba onde ficar hospedado e quais as atividades da região.',
    content: 'Onde ficar'
}, {
    href: '/experience/duvidas',
    title: 'Tire suas dúvidas sobre o Mercos Experience.',
    content: 'Dúvidas'
}],
    videosSubItems = [{
    href: '/mercoscast',
    title: 'Ouça nosso podcast.',
    content: 'Mercoscast'
}, {
    href: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hUoq30m-PK8Zx-S-lDYExX-',
    title: 'Veja nosso Mercos Minuto',
    content: 'Mercos Minuto',
    target: '_blank'
}, {
    href: '/blog/lives',
    title: 'Assista nossas lives',
    content: 'Lives'
}];

var Menu = function (_Component) {
    _inherits(Menu, _Component);

    function Menu(props) {
        _classCallCheck(this, Menu);

        var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));

        _this.handleScroll = function () {
            var pixelsToShowMenuWhite = _this.props.pixelsToShowMenuWhite;

            if (window.scrollY <= pixelsToShowMenuWhite) {
                _this.setState({ whiteBackground: false });
            } else if (!_this.state.showWhiteMenu) {
                _this.setState({ whiteBackground: true });
            }
        };

        _this.state = {
            openedMenu: false,
            whiteBackground: _this.props.whiteBackground,
            compoundUtmUrl: ''
        };
        return _this;
    }

    _createClass(Menu, [{
        key: 'clickOpenMenu',
        value: function clickOpenMenu() {
            this.setState({ openedMenu: !this.state.openedMenu });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.mutableMenu) {
                window.removeEventListener('scroll', this.handleScroll);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.mutableMenu) {
                window.addEventListener('scroll', this.handleScroll);
            }
        }
    }, {
        key: 'isTopBarVisible',
        value: function isTopBarVisible() {
            // return !Cookies.get('closed_newsletter_top_bar')
            return false;
        }
    }, {
        key: 'getMexpMenu',
        value: function getMexpMenu() {
            var _this2 = this;

            var whiteBg = this.state.whiteBackground;
            var purple = this.props.purple;

            return _react2.default.createElement(
                'nav',
                { className: (0, _classnames2.default)('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin') },
                _react2.default.createElement(
                    'div',
                    { className: 'container menu-nav-container mexp-menu' },
                    _react2.default.createElement(
                        _Link2.default,
                        { href: '/experience', className: 'navbar-logo', title: 'Ir para a p\xE1gina principal.' },
                        _react2.default.createElement(_Picture2.default, { className: 'logo-mercos-experience', src: '/images/experience/logo-mexp-' + (whiteBg ? 'gp' : purple ? 'pw' : 'gw') + '.svg', alt: 'Logo da Mercos.' })
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'no-borders', className: 'menu-button d-lg-none', ariaLabel: 'Bot\xE3o de acesso ao menu mobile.', onClick: function onClick() {
                                return _this2.clickOpenMenu();
                            } },
                        _react2.default.createElement(_Picture2.default, { src: this.state.openedMenu ? '/images/icon-cross-gray.svg' : '/images/icon-menu-sandwich-' + (whiteBg ? 'green' : 'white') + '.svg', alt: 'Bot\xE3o para visualizar o menu mobile.' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none') },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav navbar-mobile' },
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/experience#home', title: 'Ir para a p\xE1gina principal.' },
                                'Home'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/experience#sobre', title: 'Saber mais sobre o evento.' },
                                'Sobre'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/experience#palestrantes', title: 'Conhecer os palestrantes j\xE1 confirmados.' },
                                'Palestrantes'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/experience/ingressos', title: 'Comprar agora meu ingresso.' },
                                'Ingressos'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/experience/duvidas', title: 'Tire suas d\xFAvidas sobre o Mercos Experience.' },
                                'D\xFAvidas'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/experience/expositores', title: 'Quero expor no Mercos Experience.' },
                                'Expositores'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/experience/onde-ficar', title: 'Saiba onde ficar hospedado e quais as atividades da regi\xE3o.' },
                                'Onde ficar'
                            ),
                            _react2.default.createElement('hr', { className: 'divider-menu' }),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({ color: 'linkDark' }, purple && { className: 'purple' }, { type: 'button', model: 'success', href: '/experience/ingressos/', title: 'Compre agora seu ingresso.' }),
                                'COMPRAR AGORA'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'd-none d-lg-block' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav' },
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '/experience#home', title: 'Ir para a p\xE1gina principal.' }),
                                'Home'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '/experience#sobre', title: 'Saber mais sobre o evento.' }),
                                'Sobre'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '/experience#palestrantes', title: 'Conhecer os palestrantes j\xE1 confirmados.' }),
                                'Palestrantes'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '/experience/expositores', title: 'Quero expor no Mercos Experience.' }),
                                'Expositores'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '.', title: 'Tenho d\xFAvidas sobre o Mercos Experience.', subItems: participantsSubItems }),
                                'Participantes'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { className: (0, _classnames2.default)('extended-margin', purple && 'purple'), model: 'success', type: 'button', href: '/experience/ingressos', title: 'Compre agora seu ingresso.' }),
                                'COMPRAR AGORA'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getBlogMenu',
        value: function getBlogMenu() {
            var _this3 = this;

            var whiteBg = this.state.whiteBackground;

            return _react2.default.createElement(
                'nav',
                { className: (0, _classnames2.default)('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin') },
                _react2.default.createElement(
                    'div',
                    { className: 'container menu-nav-container blog-menu' },
                    _react2.default.createElement(
                        _Link2.default,
                        { href: '/blog', className: 'navbar-logo', title: 'Ir para a p\xE1gina principal.' },
                        _react2.default.createElement(_Picture2.default, { className: 'logo-mercos-blog', src: whiteBg ? '/images/blog/logo-mercos-blog-gp.png' : '/images/blog/logo-mercos-blog-gw.png', alt: 'Logo da Mercos.' })
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'no-borders', className: 'menu-button d-lg-none', ariaLabel: 'Bot\xE3o de acesso ao menu mobile.', onClick: function onClick() {
                                return _this3.clickOpenMenu();
                            } },
                        _react2.default.createElement(_Picture2.default, { src: this.state.openedMenu ? '/images/icon-cross-gray.svg' : '/images/icon-menu-sandwich-' + (whiteBg ? 'green' : 'white') + '.svg', alt: 'Bot\xE3o para visualizar o menu mobile.' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none') },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav navbar-mobile' },
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/blog/representante-comercial', title: 'Conhe\xE7a nosso conte\xFAdo para representantes comerciais' },
                                'Representante'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/blog/gestor-comercial', title: 'Conhe\xE7a nosso conte\xFAdo para gestor comercial' },
                                'Gestor Comercial'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/mercoscast', title: 'Ou\xE7a nosso podcast.' },
                                'Mercoscast'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/blog/treinamentos', title: 'Conhe\xE7a nosso conte\xFAdo para treinamento' },
                                'Treinamentos'
                            ),
                            _react2.default.createElement('hr', { className: 'divider-menu' }),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'button', model: 'success', href: '/sobre/' + this.state.compoundUtmUrl, title: 'Conhe\xE7a a Mercos.' },
                                'CONHE\xC7A A MERCOS'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'd-none d-lg-block' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav' },
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '.', title: 'Conhe\xE7a nosso conte\xFAdo', subItems: videosSubItems }),
                                'Videos'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '/blog/representante-comercial', title: 'Conhe\xE7a nosso conte\xFAdo para representantes comerciais' }),
                                'Representante'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '/blog/gestor-comercial', title: 'Conhe\xE7a nosso conte\xFAdo para gestor comercial' }),
                                'Gestor Comercial'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '/blog/treinamentos', title: 'Conhe\xE7a nosso conte\xFAdo para treinamento' }),
                                'Treinamentos'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { className: 'extended-margin-blog', type: 'button', href: '/sobre/' + this.state.compoundUtmUrl, target: '_blank', title: 'Cadastre-se no Mercos!' }),
                                'Conhe\xE7a a Mercos'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getMercoscastMenu',
        value: function getMercoscastMenu() {
            var _this4 = this;

            var whiteBg = this.state.whiteBackground;

            return _react2.default.createElement(
                'nav',
                { className: (0, _classnames2.default)('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin') },
                _react2.default.createElement(
                    'div',
                    { className: 'container menu-nav-container mercoscast-menu' },
                    _react2.default.createElement(
                        _Link2.default,
                        { href: '/mercoscast', className: 'navbar-logo', title: 'Ir para a p\xE1gina principal.' },
                        _react2.default.createElement(_Picture2.default, { className: 'logo-mercos-cast', src: whiteBg ? '/images/logo-mercoscast-pg.svg' : '/images/logo-mercoscast-pw.svg', alt: 'Logo da Mercos.' })
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'no-borders', className: 'menu-button d-lg-none', ariaLabel: 'Bot\xE3o de acesso ao menu mobile.', onClick: function onClick() {
                                return _this4.clickOpenMenu();
                            } },
                        _react2.default.createElement(_Picture2.default, { src: this.state.openedMenu ? '/images/icon-cross-gray.svg' : '/images/icon-menu-sandwich-' + (whiteBg ? 'green' : 'white') + '.svg', alt: 'Bot\xE3o para visualizar o menu mobile.' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none') },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav navbar-mobile' },
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/blog', title: 'Conhe\xE7a nosso blog.' },
                                'Mercos Blog'
                            ),
                            _react2.default.createElement('hr', { className: 'divider-menu' }),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'button', model: 'success', href: '/sobre/' + this.state.compoundUtmUrl, title: 'Conhe\xE7a a Mercos.' },
                                'CONHE\xC7A A MERCOS'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'd-none d-lg-block' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav' },
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { href: '/blog', title: 'Conhe\xE7a nosso blog.' }),
                                'Mercos Blog'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, !whiteBg && { color: 'purple' }, { className: 'extended-margin', type: 'button', href: '/sobre/' + this.state.compoundUtmUrl, target: '_blank', title: 'Cadastre-se no Mercos!' }),
                                'Conhe\xE7a a Mercos'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getMarketplaceMenu',
        value: function getMarketplaceMenu() {
            var _this5 = this;

            return _react2.default.createElement(
                'nav',
                { className: (0, _classnames2.default)('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1 bg-white border-bottom shadow-sm menu-topo-branco', this.props.logoOnly && 'logo-only', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin') },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container menu-nav-container marketplace-menu') },
                    _react2.default.createElement(
                        _Link2.default,
                        { href: '/', className: 'navbar-logo', title: 'Ir para a p\xE1gina principal da Mercos.' },
                        _react2.default.createElement(_Picture2.default, { className: 'logo-mercos', src: '/images/site/logo-mercos-mp-colored.png', alt: 'Logo da Mercos.' })
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'no-borders', className: 'menu-button d-lg-none', ariaLabel: 'Bot\xE3o de acesso ao menu mobile.', onClick: function onClick() {
                                return _this5.clickOpenMenu();
                            } },
                        _react2.default.createElement(_Picture2.default, { src: this.state.openedMenu ? '/images/icon-cross-gray.svg' : '/images/icon-menu-sandwich-green.svg', alt: 'Bot\xE3o para visualizar o menu mobile.' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none') },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav navbar-mobile' },
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/', title: 'P\xE1gina inicial.' },
                                'Home'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: '/parceiros/' + this.state.compoundUtmUrl, target: '_blank', title: 'Conhe\xE7a o programa de parceiros da Mercos.' },
                                'Programa de parceiros'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', href: 'https://blog.mercos.com/' + this.state.compoundUtmUrl, target: '_blank', title: 'Conhe\xE7a o blog da Mercos.' },
                                'Mercos Blog'
                            ),
                            _react2.default.createElement('hr', { className: 'divider-menu' }),
                            _react2.default.createElement(_PartnerContactModal2.default, { className: 'menu-cta-button', size: 'small', model: 'outline' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'd-none d-lg-block' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav' },
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', href: '/', title: 'P\xE1gina inicial.' },
                                'Home'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', href: '/parceiros/' + this.state.compoundUtmUrl, target: '_blank', title: 'Conhe\xE7a o programa de parceiros da Mercos.' },
                                'Programa de parceiros'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', href: 'https://blog.mercos.com/' + this.state.compoundUtmUrl, target: '_blank', title: 'Conhe\xE7a o blog da Mercos.' },
                                'Mercos Blog'
                            ),
                            _react2.default.createElement(_PartnerContactModal2.default, { className: 'menu-cta-button', size: 'small', model: 'outline' })
                        )
                    )
                )
            );
        }
    }, {
        key: 'getSiteMenu',
        value: function getSiteMenu() {
            var _this6 = this;

            var whiteBg = this.state.whiteBackground;
            var loginOnly = this.props.loginOnly;
            var regularLogo = this.props.regularLogo;

            return _react2.default.createElement(
                'nav',
                { className: (0, _classnames2.default)('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin') },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container menu-nav-container') },
                    _react2.default.createElement(
                        _Link2.default,
                        { href: '/', className: 'navbar-logo', title: 'Ir para a p\xE1gina principal.' },
                        regularLogo ? _react2.default.createElement(_Picture2.default, { className: 'logo-mercos', src: whiteBg ? '/images/site/logo-mercos-colored.svg' : '/images/logo_mercos_footer.svg', alt: 'Logo da Mercos.' }) : _react2.default.createElement(_Picture2.default, { className: 'logo-mercos', src: whiteBg ? '/images/site/logo-mercos-colored.svg' : '/images/logo-mercos-white.svg', alt: 'Logo da Mercos.' })
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'no-borders', className: 'menu-button d-lg-none', ariaLabel: 'Bot\xE3o de acesso ao menu mobile.', onClick: function onClick() {
                                return _this6.clickOpenMenu();
                            } },
                        _react2.default.createElement(_Picture2.default, { src: this.state.openedMenu ? '/images/icon-cross-gray.svg' : '/images/icon-menu-sandwich-' + (whiteBg ? 'green' : 'white') + '.svg', alt: 'Bot\xE3o para visualizar o menu mobile.' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none') },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav navbar-mobile' },
                            !loginOnly && _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkDark', type: 'mobile', href: '/', title: 'P\xE1gina inicial da Mercos.' },
                                    'Home'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkDark', type: 'mobile', href: '/industrias', title: 'Veja como o Mercos pode potencializar sua Ind\xFAstria.' },
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkDark', type: 'mobile', href: '/distribuidoras', title: 'Veja como o Mercos pode potencializar sua Distribuidora.' },
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkDark', type: 'mobile', href: '/representantes-comerciais', title: 'Veja como o Mercos pode potencializar o Representante Comercial.' },
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkDark', type: 'mobile', href: '/planos-e-precos', title: 'Conhe\xE7a nossos Planos e Pre\xE7os.' },
                                    'Planos e Pre\xE7os'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkDark', type: 'mobile', href: '/parceiros', title: 'Conhe\xE7a nosso programa de Parceiros.' },
                                    'Parceiros'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkDark', type: 'mobile', href: '/blog', title: 'Conhe\xE7a nosso conte\xFAdo.' },
                                    'Conte\xFAdo'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkDark', type: 'mobile', href: '/sobre', title: 'Saiba mais sobre a Mercos.' },
                                    'Sobre'
                                ),
                                _react2.default.createElement('hr', { className: 'divider-menu' })
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'mobile', onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
                                    }, href: '#', title: 'Acesse o Mercos!' },
                                'Entrar'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkDark', type: 'button', model: 'success', onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }, href: '#', title: 'Cadastre-se no Mercos.' },
                                'CADASTRE-SE'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'd-none d-lg-block' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav' },
                            !loginOnly && _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    _extends({}, whiteBg && { color: 'linkDark' }, { href: '.', title: 'Conhe\xE7a o Mercos.', subItems: softwareSubItems }),
                                    'Software'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    _extends({}, whiteBg && { color: 'linkDark' }, { href: '/planos-e-precos', title: 'Conhe\xE7a nossos Planos e Pre\xE7os.' }),
                                    'Planos e Pre\xE7os'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    _extends({}, whiteBg && { color: 'linkDark' }, { href: '.', title: 'Saiba mais sobre nossos parceiros.', subItems: partnersSubItems }),
                                    'Parceiros'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    _extends({}, whiteBg && { color: 'linkDark' }, { href: '/blog', title: 'Conhe\xE7a nosso conte\xFAdo.' }),
                                    'Conte\xFAdo'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    _extends({}, whiteBg && { color: 'linkDark' }, { href: '/sobre', title: 'Saiba mais sobre a Mercos.' }),
                                    'Sobre'
                                )
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { className: 'extended-margin', onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
                                    }, href: '#', title: 'Acesse o Mercos!' }),
                                'Entrar'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkDark' }, { type: 'button', onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }, href: '#', title: 'Cadastre-se no Mercos!' }),
                                'CADASTRE-SE'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getNewHomeSiteMenu',
        value: function getNewHomeSiteMenu() {
            var _this7 = this;

            var whiteBg = this.state.whiteBackground;
            var loginOnly = this.props.loginOnly;

            return _react2.default.createElement(
                'nav',
                { className: (0, _classnames2.default)('navbar navbar-expand-lg navbar-transition fixed-top menu-lateral effect-1', whiteBg ? 'bg-white border-bottom shadow-sm menu-topo-branco' : 'menu-topo-transparente', this.props.logoOnly ? 'logo-only' : '', this.props.purple && 'purple', this.isTopBarVisible() && 'top-bar-margin') },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container menu-nav-container new-home-container') },
                    _react2.default.createElement(
                        _Link2.default,
                        { href: '/', className: 'navbar-logo', title: 'Ir para a p\xE1gina principal.' },
                        _react2.default.createElement('div', { className: whiteBg ? 'logo-mercos-new-home-white-bg' : 'logo-mercos-new-home' })
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'no-borders', className: 'menu-button d-lg-none', ariaLabel: 'Bot\xE3o de acesso ao menu mobile.', onClick: function onClick() {
                                return _this7.clickOpenMenu();
                            } },
                        _react2.default.createElement(_Picture2.default, { src: this.state.openedMenu ? '/images/icon-cross-gray.svg' : '/images/icon-menu-sandwich-' + (whiteBg ? 'green' : 'white') + '.svg', alt: 'Bot\xE3o para visualizar o menu mobile.' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)('menu d-lg-none shadow-lg', this.state.openedMenu ? 'd-block' : 'd-none') },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav navbar-mobile' },
                            !loginOnly && _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', className: 'highlight', href: '/', title: 'P\xE1gina inicial da Mercos.' },
                                    'Home'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Conhe\xE7a o Mercos.', newSubItems: softwareSubItems },
                                    'Software'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', className: 'highlight', href: '/planos-e-precos', title: 'Conhe\xE7a nossos Planos e Pre\xE7os.' },
                                    'Planos e Pre\xE7os'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Saiba mais sobre nossos parceiros.', newSubItems: partnersSubItems },
                                    'Integra\xE7\xF5es'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Conhe\xE7a nosso conte\xFAdo.', newSubItems: conteudoSubItems },
                                    'Conte\xFAdo'
                                )
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { type: 'button', className: 'button-menu-mobile', model: 'success', onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }, href: '#', title: 'Cadastre-se no Mercos.' },
                                'comece gr\xE1tis'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { color: 'linkBlack', model: 'outline', className: (0, _classnames2.default)('highlight', 'link-menu'), onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
                                    }, href: '#', title: 'Acesse o Mercos!' },
                                'Ja possui conta? acesse aqui'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'd-none d-lg-block' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'navbar-nav new-home-navbar' },
                            !loginOnly && _react2.default.createElement(
                                _react.Fragment,
                                null,
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Conhe\xE7a o Mercos.', newSubItems: softwareSubItems },
                                    'Software'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', className: 'highlight', href: '/planos-e-precos', title: 'Conhe\xE7a nossos Planos e Pre\xE7os.' },
                                    'Planos e Pre\xE7os'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Saiba mais sobre nossos parceiros.', newSubItems: partnersSubItems },
                                    'Integra\xE7\xF5es'
                                ),
                                _react2.default.createElement(
                                    _MenuItem2.default,
                                    { color: 'linkBlack', href: '.', title: 'Conhe\xE7a nosso conte\xFAdo.', newSubItems: conteudoSubItems },
                                    'Conte\xFAdo'
                                )
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                _extends({}, whiteBg && { color: 'linkBlack' }, {
                                    className: (0, _classnames2.default)('menu-item-enter', !whiteBg && 'menu-item-enter-white'),
                                    shake: true,
                                    onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
                                    },
                                    href: '#',
                                    title: 'Acesse o Mercos!'
                                }),
                                'Entrar'
                            ),
                            _react2.default.createElement(
                                _MenuItem2.default,
                                { className: whiteBg ? 'button-menu-home-bg-white' : 'button-menu-home', shake: true, type: 'button', onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }, href: '#', title: 'Cadastre-se no Mercos!' },
                                'comece gr\xE1tis'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getSiteNavProps',
        value: function getSiteNavProps() {
            var _props = this.props,
                loginOnly = _props.loginOnly,
                mutableMenu = _props.mutableMenu,
                pixelsToShowMenuWhite = _props.pixelsToShowMenuWhite,
                isNewHome = _props.isNewHome,
                whiteBackground = _props.whiteBackground;

            var forceSolid = !!whiteBackground && !mutableMenu;
            var scrollAwareBackground = (mutableMenu || isNewHome) && !forceSolid;

            return {
                loginOnly: !!loginOnly,
                logoOnly: !!this.props.logoOnly,
                pixelsToShowMenuWhite: pixelsToShowMenuWhite || 50,
                transparentOnTop: scrollAwareBackground,
                whiteBackground: forceSolid
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.isBlog ? this.getBlogMenu() : this.props.isMercoscast ? this.getMercoscastMenu() : this.props.isMexp ? this.getMexpMenu() : this.props.isMarketplace ? this.getMarketplaceMenu() : _react2.default.createElement(_SiteNav2.default, this.getSiteNavProps())
            );
        }
    }]);

    return Menu;
}(_react.Component);

Menu.propTypes = {
    bigPadding: _propTypes2.default.bool,
    whiteBackground: _propTypes2.default.bool,
    logoOnly: _propTypes2.default.bool,
    mutableMenu: _propTypes2.default.bool,
    pixelsToShowMenuWhite: _propTypes2.default.number,
    isNewHome: _propTypes2.default.bool
};

Menu.defaultProps = {
    bigPadding: false,
    whiteBackground: false,
    logoOnly: false,
    mutableMenu: false,
    pixelsToShowMenuWhite: 100
};

exports.default = Menu;

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDeviceDetect = __webpack_require__(610);

var _Link = __webpack_require__(561);

var _Link2 = _interopRequireDefault(_Link);

var _ButtonLink = __webpack_require__(557);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuItem = function (_Component) {
    _inherits(MenuItem, _Component);

    function MenuItem(props) {
        _classCallCheck(this, MenuItem);

        var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props));

        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.setWrapperRef = _this.setWrapperRef.bind(_this);

        _this.state = {
            isOpen: false
        };
        return _this;
    }

    _createClass(MenuItem, [{
        key: 'setWrapperRef',
        value: function setWrapperRef(node) {
            this.wrapperRef = node;
        }
    }, {
        key: 'handleClickOutside',
        value: function handleClickOutside(event) {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                this.toggleDropdown();
            }
        }
    }, {
        key: 'toggleDropdown',
        value: function toggleDropdown(e) {
            e && e.preventDefault();

            if (!_reactDeviceDetect.isMobile) {
                if (this.state.isOpen) {
                    document.removeEventListener('mousedown', this.handleClickOutside);
                    document.removeEventListener('mouseover', this.handleClickOutside);
                } else {
                    document.addEventListener('mousedown', this.handleClickOutside);
                    document.addEventListener('mouseover', this.handleClickOutside);
                }
            }

            this.setState({
                isOpen: !this.state.isOpen
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var type = this.props.type;
            return _react2.default.createElement(
                'li',
                { className: (0, _classnames2.default)('nav-item', this.props.className, this.props.subItems && 'show-dropdown', this.props.newSubItems && 'show-dropdown', this.state.isOpen && 'opened'), ref: this.setWrapperRef },
                type === 'button' ? _react2.default.createElement(
                    _ButtonLink2.default,
                    { className: 'menu-cta-button',
                        color: this.props.color,
                        model: this.props.model || 'outline',
                        radius: 'half-rounded',
                        size: 'small',
                        href: this.props.href,
                        target: this.props.target,
                        title: this.props.title,
                        onClick: this.props.onClick,
                        shake: this.props.shake
                    },
                    this.props.children
                ) : _react2.default.createElement(
                    _Link2.default,
                    _extends({ className: 'nav-link' + (type === 'mobile' ? '-mobile' : ''),
                        color: this.props.color,
                        href: this.props.href,
                        title: this.props.title,
                        model: this.props.model || 'hover-underline',
                        target: this.props.target,
                        onClick: this.props.onClick
                    }, this.props.subItems && _extends({ onClick: function onClick(e) {
                            return _this2.toggleDropdown(e);
                        } }, !_reactDeviceDetect.isMobile && { onMouseOver: function onMouseOver(e) {
                            return _this2.toggleDropdown(e);
                        } }), this.props.newSubItems && _extends({ onClick: function onClick(e) {
                            return _this2.toggleDropdown(e);
                        } }, !_reactDeviceDetect.isMobile && { onMouseOver: function onMouseOver(e) {
                            return _this2.toggleDropdown(e);
                        } })),
                    this.props.children
                ),
                this.props.subItems && _react2.default.createElement(
                    'div',
                    { className: 'dropdown-menu-mercos' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'list-unstyled' },
                        this.props.subItems.map(function (item, index) {
                            return _react2.default.createElement(
                                'li',
                                { key: 'menu-subitem-' + index },
                                _react2.default.createElement(
                                    _Link2.default,
                                    { model: 'hover-underline',
                                        href: item.href,
                                        title: item.title,
                                        target: item.target },
                                    item.content
                                )
                            );
                        })
                    )
                ),
                this.props.newSubItems && _react2.default.createElement(
                    'div',
                    { className: 'new-dropdown-menu-mercos' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'list-unstyled' },
                        this.props.newSubItems.map(function (item, index) {
                            return _react2.default.createElement(
                                'li',
                                { key: 'menu-subitem-' + index },
                                _react2.default.createElement(
                                    _Link2.default,
                                    { model: 'hover-underline',
                                        href: item.href,
                                        title: item.title,
                                        color: 'linkBlack',
                                        target: item.target },
                                    item.url && _react2.default.createElement(_Picture2.default, { alt: item.title, src: item.url }),
                                    item.content
                                )
                            );
                        })
                    )
                ),
                this.props.newSubItemsv2 && _react2.default.createElement(
                    'div',
                    { className: 'new-dropdown-menu-mercos' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'list-unstyled' },
                        this.props.newSubItemsv2.map(function (item, index) {
                            return _react2.default.createElement(
                                'li',
                                { key: 'menu-subitem-' + index },
                                _react2.default.createElement(
                                    _Link2.default,
                                    { model: 'hover-underline',
                                        href: item.href,
                                        title: item.title,
                                        color: 'linkBlack',
                                        target: item.target },
                                    item.url && _react2.default.createElement(_Picture2.default, { alt: item.title, src: item.url }),
                                    item.content
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return MenuItem;
}(_react.Component);

MenuItem.defaultProps = {
    color: 'linkLight',
    href: '.'
};
exports.default = MenuItem;

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(2);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(611);

var UA = new UAParser();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: 'IE',
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DeviceTypes.Mobile;
};

var isTabletType = function isTabletType() {
  return device.type === DeviceTypes.Tablet;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DeviceTypes.Mobile:
    case DeviceTypes.Tablet:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DeviceTypes.SmartTv;
};

var isBrowserType = function isBrowserType() {
  return device.type === DeviceTypes.Browser;
};

var isWearableType = function isWearableType() {
  return device.type === DeviceTypes.Wearable;
};

var isConsoleType = function isConsoleType() {
  return device.type === DeviceTypes.Console;
};

var isAndroidType = function isAndroidType() {
  return os.name === OsTypes.Android;
};

var isWindowsType = function isWindowsType() {
  return os.name === OsTypes.Windows;
};

var isMacOsType = function isMacOsType() {
  return os.name === OsTypes.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OsTypes.WindowsPhone;
};

var isIOSType = function isIOSType() {
  return os.name === OsTypes.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BrowserTypes.Chrome;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BrowserTypes.Firefox;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BrowserTypes.Chromium;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BrowserTypes.Edge;
};

var isYandexType = function isYandexType() {
  return browser.name === BrowserTypes.Yandex;
};

var isSafariType = function isSafariType() {
  return browser.name === BrowserTypes.Safari || browser.name === BrowserTypes.MobileSafari;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BrowserTypes.MobileSafari;
};

var isOperaType = function isOperaType() {
  return browser.name === BrowserTypes.Opera;
};

var isIEType = function isIEType() {
  return browser.name === BrowserTypes.InternetExplorer || browser.name === BrowserTypes.Ie;
};

var isMIUIType = function isMIUIType() {
  return browser.name === BrowserTypes.MIUI;
};

var isSamsungBrowserType = function isSamsungBrowserType() {
  return browser.name === BrowserTypes.SamsungBrowser;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isDesktop = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();
var isSamsungBrowser = isSamsungBrowserType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!@license
 * UAParser.js v0.7.28
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.28",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=255;var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){return typeof str1===STR_TYPE?str2.toLowerCase().indexOf(str1.toLowerCase())!==-1:false},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str,len){str=str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"");return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldSafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}},oldEdge:{version:{.1:"12.",21:"13.",31:"14.",39:"15.",41:"16.",42:"17.",44:"18."}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/(?:edge|edgios|edga|edg)\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i,/(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/\s]+([\w\.]+)/i],[VERSION,[NAME,"Opera Mini"]],[/\sopr\/([\w\.]+)/i],[VERSION,[NAME,"Opera"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(ba?idubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i,/(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[VERSION,[NAME,"UCBrowser"]],[/(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i],[VERSION,[NAME,"IE"]],[/yabrowser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure Browser"],VERSION],[/focus\/([\w\.]+)/i],[VERSION,[NAME,"Firefox Focus"]],[/opt\/([\w\.]+)/i],[VERSION,[NAME,"Opera Touch"]],[/coc_coc_browser\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,"Opera Coast"]],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[NAME,"360 Browser"]],[/(oculus|samsung|sailfish)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Browser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/\s(electron)\/([\w\.]+)\ssafari/i,/(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i,/(LBBROWSER)/i],[NAME],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/FBAN\/FBIOS|FB_IAB\/FB4A/i],[[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/\s]([\w\.-]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+)\s.*safari\//i],[VERSION,[NAME,"GSA"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,"Chrome WebView"],VERSION],[/droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldSafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/ile\svr;\srv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,"Firefox Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i,/(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|armv?8e?l?)\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i],[MODEL,[VENDOR,"Samsung"],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i,/\ssamsung[\s-]([\w-]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,"Samsung"],[TYPE,MOBILE]],[/\((ip(?:hone|od)[\s\w]*);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/\((ipad);[\w\s\),;-]+apple/i,/applecoremedia\/[\w\.]+\s\((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i],[MODEL,[VENDOR,"Huawei"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i,/\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/\b(poco[\s\w]+)(?:\sbuild|\))/i,/\b;\s(\w+)\sbuild\/hm\1/i,/\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i,/\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i,/\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/;\s(\w+)\sbuild.+\soppo/i,/\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/\svivo\s(\w+)(?:\sbuild|\))/i,/\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\s(rmx[12]\d{3})(?:\sbuild|;)/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i,/\smot(?:orola)?[\s-](\w*)/i,/((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/(lm-?f100[nv]?|nexus\s[45])/i,/lg[e;\s\/-]+((?!browser|netcast)\w+)/i,/\blg(\-?[\d\w]+)\sbuild/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(ideatab[\w\-\s]+)/i,/lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia\s\d+)/i,/nokia[\s_-]?([\w\.-]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/droid.+;\s(pixel\sc)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/sony\stablet\s[ps]\sbuild\//i,/(?:sony)?sgp\w+(?:\sbuild\/|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,"Sony"],[TYPE,TABLET]],[/\s(kb2005|in20[12]5|be20[12][59])\b/i,/\ba000(1)\sbuild/i,/\boneplus\s(a\d{4})[\s)]/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi)(\sbuild\/|\))/i,/(kf[a-z]+)(\sbuild\/|\)).+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i],[[MODEL,"Fire Phone"],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((playbook);[\w\s\),;-]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i],[MODEL,[VENDOR,"ASUS"],[TYPE,TABLET]],[/\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i],[MODEL,[VENDOR,"ASUS"],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+;\s(m[1-5]\snote)\sbuild/i,/\bmz-([\w-]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i,/(microsoft);\s(lumia[\s\w]+)/i,/(lenovo)[_\s-]?([\w-]+)/i,/linux;.+(jolla);/i,/droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i,/[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i,/[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i,/\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i,/\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(surface\sduo)\s/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,TABLET]],[/droid\s[\d\.]+;\s(fp\du?)\sbuild/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/\s(u304aa)\sbuild/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/[;\/]\s?(rct\w+)\sbuild/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/[;\/\s](venue[\d\s]{2,7})\sbuild/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/[;\/]\s(tm\d{3}\w+)\sbuild/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/;\s(nx\d{3}j)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/[;\/]\s?(gen\d{3})\sbuild.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/[;\/]\s?(zur\d{3})\sbuild/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/[;\/]\s?((zeki)?tb.*\b)\sbuild/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/[;\/]\s([yr]\d{2})\sbuild/i,/[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/[;\/]\s?(ns-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/;\s(ph-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/[;\/]\s?tu_(1491)\sbuild/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w\s]+)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint)\s(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,"Zebra"],[TYPE,TABLET]],[/droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,"Zebra"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[345portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i],[[VENDOR,"LG"],[TYPE,SMARTTV]],[/(apple)\s?tv/i],[VENDOR,[MODEL,"Apple TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"],[TYPE,SMARTTV]],[/droid.+aft([\w])(\sbuild\/|\))/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i],[[TYPE,SMARTTV]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/droid.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/droid\s[\d\.]+;\s(wt63?0{2,3})\)/i],[MODEL,[VENDOR,"Zebra"],[TYPE,WEARABLE]],[/(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]],[/(phone)/i],[[TYPE,MOBILE]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,"BlackBerry"]],[/(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,"Chromecast"]],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(nintendo|playstation)\s([wids345portablevuch]+)/i,/(xbox);\s+xbox\s([^\);]+)/i,/(mint)[\/\s\(\)]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i,/\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku)\s(\w+)/i],[NAME,VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua==="object"){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _ua=ua||(typeof window!=="undefined"&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var _rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var _browser={name:undefined,version:undefined};mapper.rgx.call(_browser,_ua,_rgxmap.browser);_browser.major=util.major(_browser.version);return _browser};this.getCPU=function(){var _cpu={architecture:undefined};mapper.rgx.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(_device,_ua,_rgxmap.device);return _device};this.getEngine=function(){var _engine={name:undefined,version:undefined};mapper.rgx.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={name:undefined,version:undefined};mapper.rgx.call(_os,_ua,_rgxmap.os);return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?util.trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!=="undefined"){window.UAParser=UAParser}}var $=typeof window!=="undefined"&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ListItem = exports.UnorderedList = exports.OrderedList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(668);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderedList = exports.OrderedList = function OrderedList(_ref) {
    var children = _ref.children,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'A' : _ref$type;
    return _react2.default.createElement(
        'ol',
        { className: 'orderedList', type: type },
        children
    );
};

var UnorderedList = exports.UnorderedList = function UnorderedList(_ref2) {
    var children = _ref2.children;
    return _react2.default.createElement(
        'ul',
        { className: 'unorderedList' },
        children
    );
};

var ListItem = exports.ListItem = function ListItem(_ref3) {
    var children = _ref3.children;
    return _react2.default.createElement(
        'li',
        null,
        children
    );
};

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/site/PrivacyNotice.jsx.512bacc5.js